module.exports = __webpack_public_path__ + "img/stock2.695b1029.png";